var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecordList = function SvgRecordList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.68 3.773A3.613 3.613 0 0 0 4.28 7.375h9.453a3.59 3.59 0 0 0 3.586-3.602A3.588 3.588 0 0 0 13.734.18a3.606 3.606 0 0 0-3.601 3.593c0 .977.406 1.86 1.047 2.477H6.82a3.436 3.436 0 0 0 1.047-2.477A3.593 3.593 0 0 0 4.281.18 3.606 3.606 0 0 0 .68 3.773Zm1.132 0c0-1.359 1.102-2.46 2.47-2.46a2.464 2.464 0 1 1 0 4.93 2.464 2.464 0 0 1-2.47-2.47Zm9.454 0c0-1.359 1.101-2.46 2.468-2.46a2.46 2.46 0 0 1 2.461 2.46 2.464 2.464 0 1 1-4.93 0Z",
    fill: "#fff"
  })));
};
export default SvgRecordList;